import { useDispatch } from 'react-redux';
import React, { useState } from 'react';
import { RxCross2 } from 'react-icons/rx';

import { CustomLoader } from '../../../services/Reducer';
import apiClient from '../../../api/apiClient';
import authServices from '../../../services/AuthServices';



const Add_table = ({ show, toggle, refreshData, AddcurrentPage }) => {
  const [formData, setFormData] = useState({
    name: '',
    imoNumber: '',
    portOfRegistry: '',
    officialNumber: '',
    flag: '',
    coastal: '',

  });
  const [errors, setErrors] = useState({}); // Error state
  const dispatch = useDispatch();

  const loader = (display) => {
    dispatch(CustomLoader(display));
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });

    // Clear the error for the field being edited
    setErrors({ ...errors, [name]: '' });
  };

  const validateForm = () => {
    let formErrors = {};

    if (formData.name === '') {
      formErrors.name = 'name cannot be empty';
    }
    if (formData.imoNumber === '') {
      formErrors.imoNumber = 'imoNumber cannot be empty';
    }
    if (formData.portOfRegistry === '') {
      formErrors.portOfRegistry = 'portOfRegistry cannot be empty';
    }
    if (formData.officialNumber === '') {
      formErrors.officialNumber = 'officialNumber cannot be empty';
    }
    if (formData.flag === '') {
      formErrors.flag = 'flag cannot be empty';
    }
    if (formData.coastal === '') {
      formErrors.coastal = 'coastal cannot be empty';
    }

    setErrors(formErrors);
    return Object.keys(formErrors).length === 0; // No errors
  };

  const token = authServices.getToken();
  const handleSubmit = async (e) => {
    // e.preventDefault();
    if (!validateForm()) {
      return; // Stop submission if there are validation errors
    }

    loader('enable');

    try {

      const response = await apiClient.post('/api/admin/vessel/add', formData, {

        headers: {
          'access_token': token,
        },

      });

      if (response.data.Status === "SUCCESS") {
        setFormData({
          name: '',
          imoNumber: '',
          portOfRegistry: '',
          officialNumber: '',
          flag: '',
          coastal: '',

        });
      }
      else {
        console.log(response.data.message)
      }
    }
    catch (error) {
      console.error('catch Error :- ', error.response ? error.response.data.message : error);
    }
    finally {
      refreshData(AddcurrentPage);
      loader('disable');
      toggle(); // Close the modal after submission
      // window.location.reload();
    }
  };
  return (
    <>
      {show && (
        <>
          <div className="modal fade show d-block" id="exampleModalScrollable" tabIndex={-1} role="dialog" aria-labelledby="exampleModalScrollableTitle" aria-hidden="true">
            <div className="modal-dialog modal-dialog-scrollable">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title" id="exampleModalScrollableTitle">Add Vessel</h5>
                  <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={toggle} >< RxCross2 /></button>
                </div>
                <div className="modal-body-custom">
                  <form >

                    <div className='row w-100'>
                      <div className="spacing w-50 d-inline-block">
                        <label htmlFor="name" className="label-custom">Name</label>
                        <input
                          type="text"
                          className={`input-custom ${errors.name ? 'input-error' : ''}`}
                          id="name"
                          name="name"
                          value={formData.name}
                          onChange={handleChange}
                        />
                      </div>

                      <div className="spacing w-50 d-inline-block">
                        <label htmlFor="imoNumber" className="label-custom">IMO Number</label>
                        <input
                          type="text"
                          className={`input-custom ${errors.imoNumber ? 'input-error' : ''}`}
                          id="imoNumber"
                          name="imoNumber"
                          value={formData.imoNumber}
                          onChange={handleChange}
                        />
                      </div>
                    </div>

                    <div className='row w-100'>
                      <div className="spacing w-50 d-inline-block">
                        <label htmlFor="portOfRegistry" className="label-custom">Port Of Registry</label>
                        <input
                          type="text"
                          className={`input-custom ${errors.portOfRegistry ? 'input-error' : ''}`}
                          id="portOfRegistry"
                          name="portOfRegistry"
                          value={formData.portOfRegistry}
                          onChange={handleChange}
                        />
                      </div>

                      <div className="spacing w-50 d-inline-block">
                        <label htmlFor="officialNumber" className="label-custom">Official Number</label>
                        <input
                          type="text"
                          className={`input-custom ${errors.officialNumber ? 'input-error' : ''}`}
                          id="officialNumber"
                          name="officialNumber"
                          value={formData.officialNumber}
                          onChange={handleChange}
                        />
                      </div>
                    </div>

                    <div className='row w-100'>
                      <div className="spacing w-50 d-inline-block">
                        <label htmlFor="flag" className="label-custom">Flag</label>
                        <input
                          type="text"
                          className={`input-custom ${errors.flag ? 'input-error' : ''}`}
                          id="flag"
                          name="flag"
                          value={formData.flag}
                          onChange={handleChange}
                        />
                      </div>

                      <div className="spacing w-50 d-inline-block">
                        <label htmlFor="coastal" className="label-custom">Coastal</label>
                        <input
                          type="text"
                          className={`input-custom ${errors.coastal ? 'input-error' : ''}`}
                          id="coastal"
                          name="coastal"
                          value={formData.coastal}
                          onChange={handleChange}
                        />
                      </div>
                    </div>

                  </form>
                </div>

                <div className="modal-footer">

                  <button type="button" style={{ backgroundColor: '#F0F0F0', color: '#000', fontWeight: '500', border: "1px solid #d7dde2" }} className="btn " data-bs-dismiss="modal" onClick={toggle}>
                    Close
                  </button>
                  <button type="button" style={{ color: 'white', fontWeight: '500' }} className="btn btn-primary" onClick={handleSubmit}>
                    Submit
                  </button>

                </div>
              </div>
              {/* /.modal-content */}
            </div>
            {/* /.modal-dialog */}
          </div>
          {/* /.modal */}
        </>
      )}
    </>
  );
};

export default Add_table;
